module.exports = __webpack_public_path__ + "media/svg/tm-7b00a55c.svg";